import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const WarningIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8688 12.9453L14.8775 12.9366L8.7525 2.42906L8.74375 2.43781C8.595 2.17512 8.32375 2 8 2C7.67625 2 7.41375 2.17512 7.25625 2.43781L7.2475 2.42906L1.1225 12.9366L1.13125 12.9453C1.0525 13.0767 1 13.2168 1 13.3831C1 13.8647 1.39375 14.2587 1.875 14.2587H14.125C14.6062 14.2587 15 13.8647 15 13.3831C15 13.2168 14.9475 13.0767 14.8688 12.9453ZM7.125 12.4987V10.7475H8.875V12.4987H7.125ZM7.125 5.49375V9.87188H8.875V5.49375H7.125Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default WarningIcon;
